/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type HpRespFeaturedModule_homepage$ref: FragmentReference;
export type HpRespFeaturedModule_homepage = {|
  +featuredModule: ?{|
    +primaryItem?: ?{|
      +cta: ?string,
      +link: ?string,
      +imageUrl: ?string,
    |},
    +items?: ?$ReadOnlyArray<?{|
      +cmsId: ?number,
      +cta: ?string,
      +link: ?string,
      +imageUrl: ?string,
      +title: ?string,
    |}>,
  |},
  +$refType: HpRespFeaturedModule_homepage$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cta",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "imageUrl",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "HpRespFeaturedModule_homepage",
  "type": "Homepage",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "featuredModule",
      "name": "module",
      "storageKey": "module(type:\"featured\")",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "featured",
          "type": "String!"
        }
      ],
      "concreteType": null,
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "FeaturedModule",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "primaryItem",
              "storageKey": null,
              "args": null,
              "concreteType": "FeaturedItem",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/)
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": "FeaturedItem",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cmsId",
                  "args": null,
                  "storageKey": null
                },
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c475838af207fc4685d5e2199091397b';
module.exports = node;
